import * as yup from "yup";
import { createValidationSchema, validate } from "@";

export const createSchema = createValidationSchema({
  name: validate("req", "name"),
  email: validate("email", "email"),
  phone: validate("phone", "phone"),
  password: validate("password", "password"),
});

export const editSchema = createValidationSchema({
  name: validate("req", "name"),
  email: validate("email", "email"),
  phone: validate("phone", "phone"),
  password: yup
    .string()
    .nullable()
    .trim()
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,20}$/, {
      message: "8 احرف مع (أحرف صغيرة ، أحرف كبيرة ، ارقام و رموز)",
      excludeEmptyString: true,
    })
    .label("password"),
});

export const defaultValues = {
  id: "",
  name: "",
  email: "",
  phone: "",
  password: "",
};
